import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Box, Stack } from '@mui/material'
import CenteredCardLayout from '../../layouts/centered-card-layout'
import { isUsingProdDataRoutes } from '../../utils/api/servers'
import TransferViewOkx from './transfer-view-okx'
import TransferViewBinance from './transfer-view-binance'
import TransferViewBybit from './transfer-view-bybit'
import AuthorizationGuard from '../../components/auth/authorization-guard'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function CustomTabPanel (props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
  )
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function a11yProps (index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
const TransferViewTabs: React.FunctionComponent = () => {
  const [value, setValue] = React.useState(0)
  const useProdDataRoutes = isUsingProdDataRoutes()

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setValue(newValue)
  }

  return (
      <CenteredCardLayout addPadding={true}>
        <Stack gap={2} alignItems='center'>
            <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }} >
                <Stack direction='row' gap={1} spacing={2}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        orientation="vertical"
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="transfers"
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                        {
                            useProdDataRoutes && <Tab label='OKX' {...a11yProps(0)}/>
                        }

                        {
                            useProdDataRoutes && <Tab label='Binance' {...a11yProps(1)} />
                        }

                        {
                            useProdDataRoutes && <Tab label='Bybit' {...a11yProps(2)} />
                        }
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                        <AuthorizationGuard Component={TransferViewOkx}/>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <AuthorizationGuard Component={TransferViewBinance}/>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <AuthorizationGuard Component={TransferViewBybit}/>
                    </CustomTabPanel>
                </Stack>
            </Box>
        </Stack>
      </CenteredCardLayout>
  )
}

export default TransferViewTabs
